import React, { useState, useEffect } from 'react';

import 'react-toastify/dist/ReactToastify.css';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { get } from 'lodash';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';

import * as actions from '../../../store/modules/auth/actions';

import { displayErrors } from '../../../util/diversos';
import { Input155px, Input200px } from '../../../styles/inputGroup';

import Card from '../../../components/card';
import store from '../../../store/store';
import axiosAdmin from '../../../services/axiosAdmin';
import Loading from '../../loading';

export default function CadastroAliquotaICMSUF({ payloadCadastro, childToParentConsulta }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const id = get(payloadCadastro, 'id', 0);

  const [listaUf, setListaUf] = useState([]);
  const [uf, setUf] = useState('MG');
  const [ncm, setNcm] = useState('');
  const [aliquota, setAliquota] = useState(0);
  const [baseReducao, setBaseReducao] = useState(0);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let newTitle = 'Alíquota ICMS UF - Cadastro';
    if (id) {
      newTitle = 'Alíquota ICMS UF - Edição';
    }

    dispatch(actions.titleHeaderChange({ newTitle }));

    if (!id) return;

    async function getData() {
      try {
        setIsLoading(true);

        const { data } = await axiosAdmin.get(`/aliquotaicmsuf/${id}`);

        const idUsuario = get(store.getState().auth.user, 'id', 0);
        if (data.idUsuario !== idUsuario) {
          navigate('/consultaaliquotaicmsuf');
          toast.error('Acesso negado');
        }

        setUf(data.uf);
        setNcm(data.ncm ? data.ncm.trim() : '');
        setAliquota(data.aliquota);
        setBaseReducao(data.baseReducao);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    getData();
  }, [dispatch, id, navigate]);

  useEffect(() => {
    let mostrarMensagemErro = true;
    async function getUnidadesFederacao() {
      try {
        setIsLoading(true);

        const listDropdown = [];

        const { data: ufs } = await axiosAdmin.get('/unidadefederacao');

        ufs.forEach(element => {
          listDropdown.push({ label: element.sigla, value: element.sigla });
        });

        listDropdown.sort((a, b) => ((a.label > b.label) ? 1 : -1));

        setListaUf(listDropdown);
      } catch (err) {
        if (mostrarMensagemErro) {
          displayErrors(err, dispatch, navigate, '/', '');
        }
        mostrarMensagemErro = false;
      } finally {
        setIsLoading(false);
      }
    }
    getUnidadesFederacao();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function salvarRegistro() {
    try {
      setIsLoading(true);

      const idUsuario = get(store.getState().auth.user, 'id', 0);

      const shippingData = {
        idUsuario,
        uf: uf.toUpperCase(),
        ncm,
        aliquota,
        baseReducao,
      };

      let payloadDataTableList = {};

      if (id > 0) {
        payloadDataTableList = get(await axiosAdmin.put(`/aliquotaicmsuf/${id}`, shippingData), 'data', {});
        toast.success('Alíquota de ICMS UF atualizada com sucesso');
      } else {
        payloadDataTableList = get(await axiosAdmin.post('/aliquotaicmsuf', shippingData), 'data', {});
        toast.success('Alíquota de ICMS UF cadastrada com sucesso');
      }

      childToParentConsulta(payloadDataTableList, id);
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível atualizar o registro');
    } finally {
      setIsLoading(false);
    }
  }

  const handleCancel = () => {
    childToParentConsulta();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let formErros = false;

    if (!uf) {
      formErros = true;
      toast.error('UF deve ser informado');
    }
    if (!ncm) {
      formErros = true;
      toast.error('NCM deve ser informado');
    }
    if (aliquota < 0) {
      setAliquota(0);
    }
    if (aliquota <= 0) {
      formErros = true;
      toast.error('Alíquota deve ser informado');
    }
    if (baseReducao < 0) {
      formErros = true;
      toast.error('Base Redução deve ser maior que zero');
    }

    if (formErros) return;

    salvarRegistro();
  };

  const titulo = () => (id ? 'Alíquota ICMS UF - Alteração' : 'Alíquota ICMS UF - Inclusão');

  function botoesFinalizar() {
    return (
      <div className="card-header" style={{ marginLeft: '12px', marginRight: '12px', width: '98%' }}>
        <div className="row">
          <div className="col-lg-9">
            <div style={{ display: 'flex', justifyContent: 'start', position: 'relative', top: '20%' }}>
              <h6>{titulo()}</h6>
            </div>
          </div>
          <div className="col-lg-3">
            <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
              <button
                onClick={handleSubmit}
                type="button"
                className="btn btn-success"
              >
                <i className="pi pi-check"></i>
                Salvar
              </button>
              <button
                onClick={handleCancel}
                type="button"
                className="btn btn-danger"
              >
                <i className="pi pi-times"></i>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Loading isLoading={isLoading} />
      <Card style={{ marginTop: '16px' }}>
        <div className="row form-elo">
          { botoesFinalizar() }
        </div>
        <div className="row form-elo">
          <div className="col-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                UF*
              </Input155px>
              <Dropdown
                options={listaUf}
                value={uf}
                emptyMessage="Nenhum registro a ser exibido"
                onChange={e => setUf(e.target.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                NCM
              </Input155px>
              <InputText
                maxLength={8}
                value={ncm}
                onChange={e => setNcm(e.target.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Alíquota
              </Input155px>
              <InputNumber
                onFocus={(e) => e.target.select()}
                suffix=" %"
                mode="decimal"
                inputId="currency-br"
                minFractionDigits={2}
                maxFractionDigits={2}
                value={aliquota}
                onValueChange={e => setAliquota(e.target.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Base Redução ICMS %
              </Input155px>
              <InputNumber
                onFocus={(e) => e.target.select()}
                suffix=" %"
                mode="decimal"
                inputId="currency-br"
                minFractionDigits={2}
                maxFractionDigits={2}
                value={baseReducao}
                onValueChange={e => setBaseReducao(e.target.value)}
              />
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
